/**
 * Registry — widget-first (2.1).
 * Panels: pages/modules/registry/panels.tsx
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('registry');

export default function RegistryPage() {
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='tree' />;
}
